import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { loadAction } from '../../util/decorators';
import loadDataSources from '../../action/loadDataSources';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import ArticleList from './ArticleList.jsx';
import StoryNav from './StoryNav.jsx';
import AuthorInfoSmall from './AuthorInfoSmall.jsx';
import AuthorInfoLarge from './AuthorInfoLarge.jsx';
import InfiniteScrollLoader from '../InfiniteScrollLoader';
import ArticlePageMeta from './ArticlePageMeta';
import viasportBackend from '../../service/viasportBackend';

const INFINITE_SCROLL_ADD_ARTICLES = 5;

const getArticleDataSourceName = routeParams => {
  if (routeParams.blogs && !routeParams.slug) return null;
  if (routeParams.podcasts && !routeParams.slug) return null;

  if (routeParams.events) return 'articleWithVideo';

  return 'articleBySlug';
};

const getRelatedArticleDataSourceName = routeParams => {
  if (routeParams.blogs && routeParams.slug) return 'relatedBlogsWithSlug';
  if (routeParams.blogs && !routeParams.slug) return 'relatedBlogs';

  if (routeParams.podcasts && routeParams.slug) return 'relatedPodcastsWithSlug';
  if (routeParams.podcasts && !routeParams.slug) return 'relatedPodcasts';

  if (routeParams.events) return null;

  return 'relatedArticlesWithSlug';
};

const $loadDataSources = args => loadDataSources({
  dataSourceConfigs: _.pickBy({
    article: getArticleDataSourceName(args.routeParams),
    relatedArticles: getRelatedArticleDataSourceName(args.routeParams),
    videoSuggestions: 'videoSuggestions',
  }),
  limit: {
    videoSuggestions: 7,
    relatedArticles: INFINITE_SCROLL_ADD_ARTICLES,
  },
  ...args,
});

// Has to be loaded after the first article load to know what competition it is
const loadSummaryVideos = (args, dataSourceResponse) => {
  const competitions = _.get(dataSourceResponse, 'payload.article[0].tags.competitions[0].en.slug');

  return loadDataSources({
    dataSourceConfigs: {
      summaries: () => viasportBackend.getContentContainers(
        {competitions, 'data.tags.videoTypes': 'summary'},
        { q: true },
        null,
        10,
        0,
        args.country,
        null,
        ['data.text.body']
      ),
    },
    ...args,
  });
};

const mapStateToProps = state => ({
  dataSources: state.dataSources,
  country: state.country,
  language: state.language,
});

const mapDispatchToProps = dispatch => ({
  loadMoreRelatedArticles: (country, routeParams, offset, relatedDataSourceName) => {
    return dispatch($loadDataSources({
      dataSourceConfigs: {
        relatedArticles: relatedDataSourceName,
      },
      offset: {
        relatedArticles: offset,
      },
      country: country,
      routeParams: routeParams,
    }));
  },
});

@loadAction($loadDataSources, loadSummaryVideos)
@connect(mapStateToProps, mapDispatchToProps)
export default class ArticlePage extends React.PureComponent {
  // need to put propTypes here, otherwise they end up on the higher order component created by the @connect decorator
  static propTypes = {
    dataSources: React.PropTypes.object,
    windowSize: React.PropTypes.object,
    params: React.PropTypes.object.isRequired,
    breakpoint: React.PropTypes.number,
    country: React.PropTypes.string,
    loadMoreRelatedArticles: React.PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.currentArticleOffset = _.size(props.dataSources.relatedArticles) || 0;
    // Keep initial related article data source name.
    this.relatedDataSourceName = getRelatedArticleDataSourceName(this.props.routeParams);
  }

  componentDidUpdate(previousProps) {
    if (previousProps.routeParams !== this.props.routeParams) {
      this.currentArticleOffset = 0;
    }
  }

  loadMoreArticles() {
    const { country, routeParams, loadMoreRelatedArticles } = this.props;
    this.currentArticleOffset = this.currentArticleOffset + INFINITE_SCROLL_ADD_ARTICLES;

    if (!this.relatedDataSourceName) return;

    return loadMoreRelatedArticles(country, routeParams, this.currentArticleOffset, this.relatedDataSourceName);
  }

  render() {
    const { dataSources, routeParams, country, host, path } = this.props;
    const isBlogOrPodcastArticlePage = routeParams.blogs || routeParams.podcasts;
    const articles = (dataSources.article || []).concat(dataSources.relatedArticles || []).filter(a => !_.isEmpty(a));
    
    let isFodboldPage = false;
  	if (routeParams.sports === 'fodbold') {
  		isFodboldPage = true;
  		//console.log(` routeParams render NEWFeedPage:  ` +  JSON.stringify(routeParams.sports));
  		console.log(` routeParams render isFodboldPage:  ` +  isFodboldPage);
    }

    return (
      <PageWithSidebars additionalBroadcastAreaItem={isBlogOrPodcastArticlePage ? <AuthorInfoLarge /> : null}>
        <section>

          <ArticlePageMeta dataSources={dataSources} country={country} host={host} path={path} />

          {
            isBlogOrPodcastArticlePage &&
              <div className="hidden-sm-up">
                <div className="template-item">
                  <AuthorInfoSmall />
                </div>
              </div>
          }

          <ArticleList />
          

         
        </section>
      </PageWithSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/ArticlePage.jsx